import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { getProducts, getFeed } from '../services/api'
import { ProductCard } from '../components/products/ProductCard'
import { NyhedCard } from '../components/feed/NyhedCard'
import './HomePage.css'

function HomePage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['products', 'featured'],
    queryFn: () => getProducts({ per_page: 12, published_only: true }),
    retry: 2,
    retryDelay: 1000,
  })

  const { data: feed } = useQuery({
    queryKey: ['feed'],
    queryFn: () => getFeed(6),
    retry: 2,
  })

  const hasFeed =
    feed &&
    ((feed.new_products?.length > 0) ||
      (feed.recently_updated?.length > 0) ||
      (feed.new_reviews?.length > 0))

  return (
    <div className="page-shell home-page">
      <section className="home-hero">
        <h1>Find det perfekte padel bat</h1>
        <p>
          Sammenlign padel bats på specs, spillestil og anmeldelser.
          Se den komplette oversigt og find det bat, der passer til dig.
        </p>
        <Link to="/bat" className="home-cta">
          Se padel bats
        </Link>
      </section>

      {hasFeed && (
        <section className="page-section">
          <h2 className="page-section-title">Nyeste nyheder</h2>
          <div className="nyheder-grid">
            {feed.new_products?.slice(0, 3).map((p) => (
              <NyhedCard key={`np-${p.id}`} item={{ type: 'product', product: p }} />
            ))}
            {feed.new_reviews?.slice(0, 2).map((r) => (
              <NyhedCard key={`nr-${r.id}`} item={{ type: 'review', ...r }} />
            ))}
            {feed.recently_updated?.slice(0, 2).map((p) => (
              <NyhedCard key={`ru-${p.id}`} item={{ type: 'updated', product: p }} />
            ))}
          </div>
          <Link to="/nyheder" className="page-section-link">
            Se alle nyheder
          </Link>
        </section>
      )}

      <section className="page-section">
        <h2 className="page-section-title">Padel bats</h2>
        {isLoading ? (
          <div className="page-loading">Indlæser...</div>
        ) : error ? (
          <div className="page-error">
            <p>Fejl ved indlæsning af produkter: {error.message}</p>
            <p>Prøv at opdatere siden.</p>
          </div>
        ) : !data?.products?.length ? (
          <div className="page-empty">Ingen produkter fundet.</div>
        ) : (
          <div className="product-grid">
            {data.products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
        <Link to="/bat" className="page-section-link">
          Se alle bat (komplet oversigt med år)
        </Link>
      </section>
    </div>
  )
}

export default HomePage
